import { gql } from '@apollo/client';

export const ORDER = gql`
  query Order($id: ID!) {
    order(id: $id) {
      id
      type
      date
      title
      createdById
      createdBy {
        id
        name
        email
      }
      status
      data
      meta
      createdAt
      updatedAt
    }
  }
`;

export const ORDERS = gql`
  query Orders($page: Int, $pageSize: Int) {
    orders(page: $page, pageSize: $pageSize) {
      items {
        id
        type
        date
        title
        createdById
        createdBy {
          id
          name
          email
        }
        status
        data
        meta
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;
